























































































import Vue from 'vue'
import { TranslateResult } from 'vue-i18n'
import { KeyActionEnum, SnackbarStateEnum } from '@/types/enums'
import { AddressEmployee } from '@/model/addresses/AddressEmployee'
import DeleteDialog from '@/components/DeleteDialog.vue'
import NotesDialog from '@/components/master-data/address/NotesDialog.vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import {
  COMPANY_FETCH_COMPANY_STRUCTURE,
  FETCH_ADDRESS_RESPONSIBLE_EMPLOYEE_LIST,
  FETCH_NOTES,
  FETCH_NOTES_TYPE_LIST,
  SAVE_NOTE
} from '@/store/action-types'
import { COMPANY_GET_BASIC_COMPANY_STRUCTURE } from '@/store/getter-types'
import { Employee } from '@/model/companyStructure/Employee'
import { NoteType } from '@/model/addresses/NoteType'
import { Note } from '@/model/addresses/Note'
import moment from 'moment'
import { NotePayload } from '@/types/payload'
import { AdressenNotizenIndexResponse, VerantwortungsDataResponse } from '@/types/service-response'
import { keyActionService } from '@/services/key-action-service'
import { KeyAction } from '@/model/KeyAction'
import SmallQualityCellRenderer from '@/components/cell-renderer/SmallQualityCellRenderer.vue'
import { ResponsibleEmployee } from '@/model/addresses/ResponsibleEmployee'
import ProgressCircular from '@/components/ProgressCircular.vue'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel, DxScrolling, DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}

interface ComponentData {
  tableHeight: string,
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  employeeList: Employee[]
  noteTypeList: NoteType[]
  responsibleEmployeeList: ResponsibleEmployee[]
  gridData: Note[]

  currentSelectedRowData: Note | undefined
  showDialog: boolean
  showDeleteDialog: boolean
  loadingData: boolean

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'Notes',

  components: {
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring,
    SmallQualityCellRenderer,
    DeleteDialog,
    NotesDialog,
    ProgressCircular
  },

  props: {
    addressId: Number,
    addressEmployee: Array as () => Array<AddressEmployee>
  },

  data (): ComponentData {
    return {
      tableHeight: '',
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      employeeList: [],
      noteTypeList: [],
      responsibleEmployeeList: [],
      gridData: [],

      currentSelectedRowData: undefined,
      showDialog: false,
      showDeleteDialog: false,
      loadingData: false,

      keyActions: []
    }
  },

  watch: {
    addressId (newVal: number): void {
      if(newVal && newVal !== 0) {
        this.currentSelectedRowData = undefined
        this.fetchData()
        this.fetchNoteTypeList()
        this.fetchNotesData()
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isEnableButtons (): boolean {
      return !!(this.currentSelectedRowData && this.currentSelectedRowData.id)
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | null): boolean {
      if(action instanceof Create) {
        return true
      } else if(action instanceof Edit) {
        return this.isEnableButtons
      } else if(action instanceof Delete) {
        return this.isEnableButtons
      } else {
        return false
      }
    },

    formatDate(item: string): string {
      return moment(item, 'DD.MM.YYYY HH:mm:ss').isValid() ? moment(item, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY') : ''
    },

    formatDateToDate(item: string): string {
      return moment(item, 'DD.MM.YYYY HH:mm:ss').isValid() ? moment(item, 'DD.MM.YYYY HH:mm:ss').toISOString() : ''
    },

    getNoteType (id: number | null): string {
      if(id) {
        const noteType: NoteType | undefined = this.noteTypeList.find((item: NoteType) => item.id === id)
        return noteType ? noteType.name : ''
      } else {
        return ''
      }
    },

    getEmployeeFullName (id: number | null): string {
      if(id) {
        const employee: Employee | undefined = this.employeeList.find((item: Employee) => item.id === id)
        return employee ? employee.fullName : ''
      } else {
        return ''
      }
    },

    onRowClick (rowData: any): void {
      this.currentSelectedRowData = rowData.data
    },

    onRowDblClick (rowData: any): void {
      this.currentSelectedRowData = rowData.data
      this.showDialog = true
    },

    onAddNoteClick (): void {
      this.currentSelectedRowData = undefined
      //@ts-ignore
      setTimeout(() => {this.$refs.dataGrid.instance.selectRows([])}, 100)
      this.showDialog = true
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onAddNoteClick()
    },

    onEditNoteButtonClick (): void {
      this.showDialog = true
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onEditNoteButtonClick()
    },

    dialogSaved (): void {
      this.fetchNotesData()
      this.showDialog = false
    },

    closeDialog (): void {
      this.showDialog = false
    },

    onDeleteNoteButtonClick (): void {
      this.showDeleteDialog = true
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onDeleteNoteButtonClick()
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
        if(this.currentSelectedRowData && this.currentSelectedRowData.id) {
          const payload: NotePayload = {
            id: this.currentSelectedRowData.id,
            selectedAddressEmployeeId: null,
            selectedAddressEmployeeName: this.currentSelectedRowData.addressEmployee ? this.currentSelectedRowData.addressEmployee : '',
            selectedResponsibleEmployee: this.currentSelectedRowData.responsibleEmployee ? this.currentSelectedRowData.responsibleEmployee : null,
            selectedAddressResponsibleEmployee: this.currentSelectedRowData.addressResponsibleEmployee ? this.currentSelectedRowData.addressResponsibleEmployee : null,
            quality: this.currentSelectedRowData.quality ? this.currentSelectedRowData.quality : null,
            dateStartIso: this.currentSelectedRowData.dateStartIso,
            dateEndIso: this.currentSelectedRowData.dateEndIso,
            alreadyDone: this.currentSelectedRowData.alreadyDone,
            selectedAuthor: this.currentSelectedRowData.author ? this.currentSelectedRowData.author : null,
            isPrivate: this.currentSelectedRowData.isPrivate,
            noteType: this.currentSelectedRowData.noteType ? this.currentSelectedRowData.noteType : null,
            noteTitle: this.currentSelectedRowData.noteTitle,
            noteText: this.currentSelectedRowData.noteText,
            addressId: this.addressId,
            action: 'Delete'
          }

          this.deleteNote(payload)
        }
    },

    async deleteNote (payload: NotePayload): Promise<void> {
      try {
        let response: AdressenNotizenIndexResponse = await this.$store.dispatch(SAVE_NOTE, payload)
        if(!response.IsError) {
          this.onDeleteDialogClose()
          this.messageSnackbar = this.$t('success.dataHaveBeenDeleted')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.fetchNotesData()
        } else {
          this.onDeleteDialogClose()
          this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchNotesData (): Promise<void> {
      this.currentSelectedRowData = undefined
      //@ts-ignore
      setTimeout(() => {this.$refs.dataGrid.instance.selectRows([])}, 100)

      try {
        this.loadingData = true
        this.gridData = await this.$store.dispatch(FETCH_NOTES, this.addressId)
      } catch {

      } finally {
        this.loadingData = false
      }
    },

    async fetchNoteTypeList (): Promise<void> {
      try {
        this.loadingData = true
        this.noteTypeList = await this.$store.dispatch(FETCH_NOTES_TYPE_LIST)
      } catch {

      } finally {
        this.loadingData = false
      }
    },

    async fetchData (): Promise<void> {
      try {
        this.loadingData = true
        await this.$store.dispatch(COMPANY_FETCH_COMPANY_STRUCTURE)
        this.employeeList = (this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]).employeeList
      } catch {

      } finally {
        this.loadingData = false
      }
    },

    async fetchResponsibleEmployeeList (): Promise<void> {
      try {
        this.loadingData = true
        const response: VerantwortungsDataResponse = await this.$store.dispatch(FETCH_ADDRESS_RESPONSIBLE_EMPLOYEE_LIST, this.addressId)
        if (response && !response.IsError) {
          this.responsibleEmployeeList = ResponsibleEmployee.createFromResponse(response.Data)
        }
      } catch {

      } finally {
        this.loadingData = false
      }
    },

    onResize (): void {
      const vh = window.innerHeight
      if(vh > 405) {
        this.tableHeight = `height: calc(${vh}px - 232px)`
      } else {
        this.tableHeight = 'height: 300px'
      }
    },
  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
    ]
  },

  async mounted () {
    window.addEventListener('keydown', this.onKeydown)
    await this.fetchData()
    await this.fetchNoteTypeList()
    await this.fetchNotesData()
    await this.fetchResponsibleEmployeeList()
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
